export const ASK_EXAMPLES = [
  'How can I find peace during trials?',
  'How can I strengthen my faith in Jesus Christ?',
  'How can I recognize personal revelation?',
  'What did speakers teach about serving others with love?',
  'How should I prepare for the Second Coming?',
] as const;
